<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'SolutoButton',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'normal'
    },
    text: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: String,
      required: false,
      default: 'primary'
    },
    color: {
      type: String,
      required: false,
      default: '#d23a00'
    },
    textColor: {
      type: String,
      required: false,
      default: '#ffffff'
    }
  },
  methods: {
    handleTouchStart () {
      // Intentionally empty: enables touchstart listener for iOS tap behavior.
    }
  },
  computed: {
    isDisabled () {
      return this.disabled;
    },
    styleObject: function () {
      return {
        '--color': !this.disabled && this.color,
        '--text-Color': !this.disabled && this.textColor
      };
    }
  }
});
</script>

<template>
  <button
      class="button"
      @click="$emit('click')"
      @touchstart.passive="handleTouchStart"
      :style="styleObject"
      :class="{
        disabled: isDisabled,
        primaryLarge: size === 'large',
        primaryNormal: size === 'normal',
        primarySmall: size === 'small',
        primary: type === 'primary',
        outlined: type === 'outlined',
        text: type === 'text'
      }"
  >
  {{text}}
  </button>
</template>

<style lang="scss" scoped>
  .button {
    outline: none;
    // tap feedback.
    &:active {
      opacity: 0.7;
    }
  }
  .primaryLarge {
    height: 48px;
    border-radius: 24px;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
    font-family: $font-family;
  }
  .primaryNormal {
    height: 36px;
    border-radius: 18px;
    font-size: 14px;
  }
  .primarySmall {
    height: 28px;
    border-radius: 14px;
    font-size: 12px;
  }
  .primary {
    background-color: var(--color);
    color: var(--text-Color);
    border: none;
    width: 100%;
    &.disabled {
      pointer-events: none;
      background-color: #e6e6e6;
      color: #c3c3c3;
    }
  }
  .outlined {
    color: #1b1b1b;
    background-color: #ffffff;
    font-family: $font-family;
    border: 2px solid var(--color);
    width: 100%;
    box-sizing: border-box;
  }
  .text {
    font-size: 15px;
    font-weight: bold;
    color: #d23a00;
    background-color: white;
    border: none;
    text-decoration: underline;
    width: 40%;
    &.disabled {
      pointer-events: none;
      color: #c3c3c3;
    }
  }
</style>
